import React from "react";
import BiddingScreen from "../../../../../Components/ReverseAuction/Bidding/BiddingScreen";

const BiddingConsumer = ({ type }) => {
  return <BiddingScreen type={type} />;
};

export default BiddingConsumer;
